/**
 * Give it a map and an array of keys and you get back a new map with only those keys.
 *
 * @param obj a map of key/value pairs
 * @param keys an array of keys to select
 * @returns a new map that only contains the keys you specified
 */
// eslint-disable-next-line @typescript-eslint/ban-types -- we want Object here
export function selectKeys<TObject extends Object, TKeys extends keyof TObject>(
  obj: TObject,
  keys: TKeys[]
) {
  const result: Partial<TObject> = {};
  for (const key of keys) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (result as any)[key as any] = (obj as any)[key];
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return result as TObject;
}
